function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
  fill: "white",
  fillOpacity: 0.05
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3333 8H19.3333C18.9646 8 18.6667 8.29792 18.6667 8.66667C18.6667 9.03542 18.9646 9.33333 19.3333 9.33333H21.7229L17.5292 13.5292C17.2688 13.7896 17.2688 14.2125 17.5292 14.4729C17.6583 14.6021 17.8292 14.6688 18 14.6688C18.1708 14.6688 18.3417 14.6042 18.4708 14.4729L22.6667 10.2771V12.6667C22.6667 13.0354 22.9646 13.3333 23.3333 13.3333C23.7021 13.3333 24 13.0354 24 12.6667V8.66667C24 8.29792 23.7021 8 23.3333 8ZM13.5292 17.5292L9.33333 21.7229V19.3333C9.33333 18.9646 9.03542 18.6667 8.66667 18.6667C8.29792 18.6667 8 18.9646 8 19.3333V23.3333C8 23.7021 8.29792 24 8.66667 24H12.6667C13.0354 24 13.3333 23.7021 13.3333 23.3333C13.3333 22.9646 13.0354 22.6667 12.6667 22.6667H10.2771L14.4729 18.4708C14.7333 18.2104 14.7333 17.7875 14.4729 17.5271C14.2104 17.2688 13.7896 17.2688 13.5292 17.5292Z",
  fill: "#C4C4C4"
});

function SvgCyclesFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclesFullscreen);
export default __webpack_public_path__ + "static/media/cyclesFullscreen.5c814c9a1f6893709821637dcea7f587.svg";
export { ForwardRef as ReactComponent };